import React, { Component } from "react";

import YaystackNavBar from "../components/yaystackNavBar";
import SearchUser from "../components/search/search_user";

import { SearchType } from "../helper/type_helper";
import SearchDataSelection from "../components/search/search_data_selection";
import SearchHashtag from "../components/search/search_hashtag";
import SearchRecommendations from "../components/search/search_recommendations";

import qs from "qs";
class Search extends Component {
  state = { query: "", show: SearchType.users };

  componentWillMount() {
    const query = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true
    });
    if (query.query_search) {
      this.setState({ query: query.query_search });
    }

    if (query.query_show) {
      if (parseInt(query.query_show, 10) === SearchType.recommendations) {
        // this.setState({ show: SearchType.recommendations });
      } else if (parseInt(query.query_show, 10) === SearchType.users) {
        this.setState({ show: SearchType.users });
      } else if (parseInt(query.query_show, 10) === SearchType.hashtags) {
        // this.setState({ show: SearchType.hashtags });
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        {/* <YaystackNavBar /> */}
        <div className="center">
          <input
            type="text"
            className="width_100 yaystack_input_text search_input"
            value={this.state.query}
            onChange={this.handleChangeQuery}
            placeholder="Search"
          />
          {/* <SearchDataSelection
            show={this.state.show}
            handleChangeToUser={this.handleChangeToUser}
            handleChangeToHashtag={this.handleChangeToHashtag}
            handleChangeToRecommendation={this.handleChangeToRecommendation}
          /> */}
          {this.renderSearch()}
        </div>
      </React.Fragment>
    );
  }

  handleChangeQuery = event => {
    this.setState({ query: event.target.value });
    this.props.history.push(
      `?query_search=${event.target.value}&query_show=${this.state.show}`
    );
  };

  handleChangeToUser = event => {
    this.setState({ show: SearchType.users });
    this.props.history.push(
      `?query_search=${this.state.query}&query_show=${SearchType.users}`
    );
  };
  handleChangeToHashtag = event => {
    this.setState({ show: SearchType.hashtags });
    this.props.history.push(
      `?query_search=${this.state.query}&query_show=${SearchType.hashtags}`
    );
  };
  handleChangeToRecommendation = event => {
    this.setState({ show: SearchType.recommendations });
    this.props.history.push(
      `?query_search=${this.state.query}&query_show=${
        SearchType.recommendations
      }`
    );
  };

  renderSearch() {
    return (
      <div className="">
        <SearchRecommendations
          show={this.state.show}
          query={this.state.query}
        />
        <SearchHashtag show={this.state.show} query={this.state.query} />
        <SearchUser show={this.state.show} query={this.state.query} />
      </div>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/pages/search.jsx